(function() {
    if (customElements.get('base-overlay-loader') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        @keyframes rotate {
          0% {transform: rotate(0deg);}
          100% {transform: rotate(360deg);}
        }
        @keyframes default-icon {
          0% {border-radius: 0;}
          50% {border-radius: .75em;}
          100% {border-radius: 0;}
        }
        :host {
          --overlay-loader-bg: black;
          --overlay-loader-fg: white;
          --overlay-loader-opacity: .5;
          z-index: 1001;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        :host([stretch]) {
          height: 100%;
        }
        [part="back"] {
          position: absolute;
          inset: 0;
          z-index: 0;
          background: var(--overlay-loader-bg);
          opacity: var(--overlay-loader-opacity);
        }
        [part="content"] {
          text-align: center;
          color: var(--overlay-loader-fg);
          position: relative;
          z-index: 1;
        }
        [part="icon-container"] {
          display: inline-block;
          transform-origin: center center;
          line-height: 0;
        }
        :host([animate]) {
          --animation-speed: 2s;
          --animation-timing-function: linear;
          --animation-name: rotate;
        }
        :host([animate]) [part="icon-container"] {
          animation: var(--animation-name) var(--animation-speed) var(--animation-timing-function) 0s infinite both;
        }
        [part="text"] {
          display: block;
          margin: 1em auto;
        }
        [part="default-icon"] {
          display: block;
          border: 5px solid currentColor;
          font-size: 2rem;
          width: 1em;
          height: 1em;
          line-height: 0;
          animation: default-icon var(--animation-speed) var(--animation-timing-function) 0s infinite both;
        }
        </style>
        <span part="back"></span>
        <span part="content">
            <span part="icon-container">
                <slot name="icon">
                    <span part="default-icon"></span>
                </slot>
            </span>
            <span part="text">
                <slot>loading</slot>
            </span>
        </span>
        `
        customElements.define('base-overlay-loader', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
        });
    }
})();
